//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../../src/lib/date';
import VueUeditorWrap from 'vue-ueditor-wrap';
import fileUploader from '../../../views/common-components/file-uploader';
import SelectProjectModal from '../components/select-project-modal';

export default {
    name: 'progressDetail',
    components: {
        SelectProjectModal,
        VueUeditorWrap,
        fileUploader
    },
    data() {
        return {
            loading: false,
            id: 0,
            progressInfo: {
                file: { associateType: 'ProjectProgress' }
            },
            name: 'name1',
            rules: {
                projectName: [{ required: true, message: '请选择项目', trigger: 'blur' }],
                uploader: [{ required: true, message: '不能为空', trigger: 'blur' }],
                month: [{ required: true, message: '请选择月份', trigger: 'change' }],
                year: [{ required: true, type: 'string', message: '请选择年份', trigger: 'change' }
                ]
            },
            showEditProgress: false,
            saving: false,
            editorConfig: {
                UEDITOR_HOME_URL: '/UEditor/'
            },
            fUeditor: null,
            finance: {
                content: ''
            },
            ueditor: null,
            showAddProjectModal: false,
            months: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
            showEditProgressContent: false
        };
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    methods: {
        getProgressInfo() {
            if (this.id <= 0) {
                return;
            }
            var vm = this;
            vm.loading = true;
            vm.$store.dispatch({
                type: 'progress/GetProjectProgressById',
                id: vm.id
            }).then(() => {

                vm.progressInfo = JSON.parse(JSON.stringify(vm.$store.state.progress.progressInfo));

                vm.progressInfo.file = { associateType: 'ProjectProgress' };
                vm.finance.content = vm.progressInfo.content;

            }).finally(() => {
                vm.loading = false;
            });
        },
        editProgress(row) {
            this.$router.push({ path: '/progressEdit/' + row.id });
        },
        showAddProject() {
            this.showAddProjectModal = true;
        },
        addProject(data) {
            // console.log(data);
            const vm = this;
            vm.progressInfo.projectId = data.id;
            vm.progressInfo.projectName = data.name;
            vm.showAddProjectModal = false;
        },
        onSaveInfo() {
            const vm = this;
            this.$refs.progressInfoForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    vm.$store.dispatch({
                        type: 'progress/saveProjectProgress',
                        data: vm.progressInfo
                    }).then(() => {

                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        // vm.activityId = vm.$store.state.activity.activityId;
                        // vm.activity.id = vm.activityId;
                        vm.showEditProgress = false;
                        vm.getProgressInfo();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        fEditorReady(editor) {
            this.ueditor = editor;
            this.finance = {
                content: ''
            };
        },
        onProgressContent() {
            var vm = this;
            vm.finance.id = this.id;
            vm.saving = true;
            abp.ajax.post('/api/services/app/ProjectProgress/SaveProgressContent', vm.finance).then(() => {
                // vm.$router.push({ path: '/project/progresses' });
                vm.showEditProgressContent = false;
                vm.getProgressInfo();
            }).finally(() => {
                vm.saving = false;
            });
        },
        onShowEditProgressContent() {
            this.finance.content = this.progressInfo.content;
            console.log(this.finance);
            this.showEditProgressContent = true;

        },
        onTabsClick() {
            this.showEditProgress = false;
            this.showEditProgressContent = false;
        },
        changeAuditStatus(a) {

            var p = {
                id: this.id,
                auditStatus: a
            };
            var vm = this;
            vm.saving = true;
            vm.$store.dispatch({
                type: 'progress/changeAuditStatus',
                data: p
            }).then(() => {

                var t = '';
                if (a == 1) {
                    t = '审核成功';
                } else {
                    t = '撤销成功';
                }
                vm.$Notice.success({
                    duration: 3,
                    title: t
                });
                vm.name = 'name1';
                vm.getProgressInfo();
            }).finally(() => {
                vm.saving = false;
            });
        },
        del() {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    this.saving = true;
                    abp.ajax.delete('/api/services/app/ProjectProgress/DeleteProgressById?id=' + this.id).then(() => {
                        this.$router.push({ path: '/project/progresses' });
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getProgressInfo();
        console.log(this.$store.state.app.cachePage);
    }
};
